import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import addFleetLimitServices from '@src/services/addFleetLimit/addFleetLimit.services';

export const createFleetLoadBalance = createAsyncThunk(
  'createFleetLoadBalance',
  async ({ data }, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      let request = { ...data };
      if (!request.customerId) {
        request.customerId = customerId;
      }
      const res = await addFleetLimitServices.createFleetLoadBalance({ request });
      return res;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const createFleetLoadBalanceSuccess = createAsyncThunk(
  'createFleetLoadBalanceSuccess',
  async ({ data }, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      let request = { ...data };
      if (!request.customerId) {
        request.customerId = customerId;
      }
      const res = await addFleetLimitServices.createFleetLoadBalanceSuccess({ request });
      return res;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  fleetLoadBalanceId: 0,
};

export const addFleetLimitSlice = createSlice({
  name: 'addFleetLimit',
  initialState,
  reducers: {
    resetCurrentLoadCostCenter: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createFleetLoadBalance.pending, (state, action) => {})
      .addCase(createFleetLoadBalance.fulfilled, (state, action) => {
        state.fleetLoadBalanceId = action?.payload?.data || [];
      })
      .addCase(createFleetLoadBalance.rejected, (state) => {
        state.fleetLoadBalanceId = 0;
      });
  },
});
